import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useBeneficiarySelectionLogic } from './hooks/useBeneficiarySelectionLogic';
import { BeneficiarySelectionForm } from './BeneficiarySelectionForm';

export const EddBeneficiarySelection = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useBeneficiarySelectionLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.beneficiarySelection.title')}
        text={t('organic.beneficiarySelection.question')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'>
        <BeneficiarySelectionForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
